import * as actionType from './type';

const INITIAL_STATE = {
    telecallingDetails: [],
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.REQUEST_TELECALLING_DETAILS_: {
            return {
                ...state,
            }
        }

        case actionType.RECEIVED_TELECALLING_DETAILS_: {
            return {
                ...state,
                isLoading: false,
                telecallingDetails : action.payload
            }
        }

        case actionType.RECEIVED_ERROR: {
            return {
                ...state,
                error: "Please try again"
            }
        }

        default: 
            return state;
    }
}